import React from "react";
import { Link } from "gatsby";

import useWindowDimensions from "../../hooks/useWindowDimensions";

import { BreadcrumbsTypes } from "../../types/breadcrumbs";

const Breadcrumbs = ({ breadcrumbs }: BreadcrumbsTypes) => {
  const { isSmallScreen } = useWindowDimensions();

  const renderBreadcrumbs = () => {
    return breadcrumbs.map(({ label, to, id, home }) => {
      return (
        <Link
          key={id}
          className={`a-breadcrumbs__item ${home ? "-home" : ""} ${
            to === "" ? "-noLink" : ""
          }`}
          to={`${to}` || ""}
        >
          {label}
        </Link>
      );
    });
  };

  return (
    <div className="fullWidth border-separator">
      <div className="_wr">
        <div className="_w">
          <div className="_12 a-breadcrumbs aligned-center -gap20 flex-wrap -pt5 -pb5">
            {renderBreadcrumbs()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumbs;
